import React from 'react'
import { Header } from '@vedmarket/ui-kit'

const DemoHeader = (props: DemoHeaderProps) => (
  <div className='demo-header' data-demo-allowed='header'>
    <Header {...props} />
  </div>
)

export default DemoHeader
